export const GetFeedbackMessageFor = (errors, key) => {
  if (typeof errors === "object") {
    return (typeof errors[key] === "object") ? errors[key].join(' - ') : errors[key];
  }
  else {
    return errors;
  }
}